

// import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { Mic, Square, Play, Save, Search, Check, User, LogOut } from 'lucide-react';
// import ApiService from '../ApiService';

// const KoreanSyllableRecorder = () => {
//   const [currentPage, setCurrentPage] = useState('recorder');
//   const [recordings, setRecordings] = useState({});
//   const [hangulSyllables, setHangulSyllables] = useState([]);
//   const [currentSyllableIndex, setCurrentSyllableIndex] = useState(0);
//   const [isRecording, setIsRecording] = useState(false);
//   const [tempRecording, setTempRecording] = useState(null);
//   const [hasListenedToRecording, setHasListenedToRecording] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [isSaving, setIsSaving] = useState(false);
//   const [loadingStatus, setLoadingStatus] = useState(false);
//   const [recordMode, setRecordMode] = useState('unrecorded');
  
//   const [speaker, setSpeaker] = useState('');
//   const [speakerInput, setSpeakerInput] = useState('');
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
  
//   const mediaRecorderRef = useRef(null);
//   const audioChunksRef = useRef([]);
//   const apiService = useRef(new ApiService());

//   const initializeMicrophone = useCallback(() => {
//     navigator.mediaDevices.getUserMedia({ audio: true })
//       .then(stream => {
//         const mediaRecorder = new MediaRecorder(stream);
//         mediaRecorderRef.current = mediaRecorder;
        
//         mediaRecorder.ondataavailable = (event) => {
//           audioChunksRef.current.push(event.data);
//         };
        
//         mediaRecorder.onstop = () => {
//           const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
//           const audioUrl = URL.createObjectURL(audioBlob);
//           setTempRecording({ blob: audioBlob, url: audioUrl });
//           setHasListenedToRecording(false);
//           audioChunksRef.current = [];
//         };
//       })
//       .catch(err => console.error('Error accessing microphone:', err));
//   }, []);

//   const loadRecordingsStatus = useCallback(async () => {
//     if (!speaker) return;
    
//     try {
//       setLoadingStatus(true);
//       const status = await apiService.current.getSyllableRecordingsStatus({ 
//         language: 'KR', 
//         speaker: speaker 
//       });
//       console.log('status: ', status);
      
//       const syllables = Object.keys(status);
//       setHangulSyllables(syllables);
      
//       const formattedRecordings = {};
//       Object.entries(status).forEach(([syllable, exists]) => {
//         if (exists) {
//           formattedRecordings[syllable] = { saved: true };
//         }
//       });
//       setRecordings(formattedRecordings);
      
//       const allRecorded = syllables.every(syllable => formattedRecordings[syllable]?.saved);
//       if (allRecorded) {
//         setRecordMode('all');
//       }
//     } catch (error) {
//       console.error('Error loading recordings status:', error);
//       setHangulSyllables([]);
//     } finally {
//       setLoadingStatus(false);
//     }
//   }, [speaker]);

//   useEffect(() => {
//     const savedSpeaker = localStorage.getItem('syllableRecorderSpeaker');
//     if (savedSpeaker) {
//       setSpeaker(savedSpeaker);
//       setSpeakerInput(savedSpeaker);
//       setIsLoggedIn(true);
//     }
//   }, []);

//   useEffect(() => {
//     if (isLoggedIn && speaker) {
//       loadRecordingsStatus();
//       initializeMicrophone();
//     }
//   }, [isLoggedIn, speaker, loadRecordingsStatus, initializeMicrophone]);

//   const handleLogin = () => {
//     const trimmedName = speakerInput.trim().toLowerCase().replace(/\s+/g, '_');
//     if (trimmedName) {
//       setSpeaker(trimmedName);
//       localStorage.setItem('syllableRecorderSpeaker', trimmedName);
//       setIsLoggedIn(true);
//     }
//   };

//   const handleLogout = () => {
//     setSpeaker('');
//     setSpeakerInput('');
//     setIsLoggedIn(false);
//     setHangulSyllables([]);
//     setRecordings({});
//     localStorage.removeItem('syllableRecorderSpeaker');
//   };

//   const playCloudRecording = async (syllable) => {
//     try {
//       const blob = await apiService.current.getProfessionalSyllableRecording({ 
//         syllable, 
//         format: 'webm',
//         speaker 
//       });
//       const audioUrl = URL.createObjectURL(blob);
//       const audio = new Audio(audioUrl);
      
//       audio.play();
//       audio.addEventListener('ended', () => {
//         URL.revokeObjectURL(audioUrl);
//       });
//     } catch (error) {
//       console.error('Error playing cloud recording:', error);
//       alert('Error playing recording. Please try again.');
//     }
//   };

//   const blobToBase64 = (blob) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         const base64String = reader.result.split(',')[1];
//         resolve(base64String);
//       };
//       reader.onerror = reject;
//       reader.readAsDataURL(blob);
//     });
//   };

//   const getAudioFormatFromBlob = (blob) => {
//     const mimeType = blob.type;
//     const formatMap = {
//       'audio/webm': 'webm',
//       'audio/wav': 'wav',
//       'audio/mpeg': 'mp3',
//       'audio/mp3': 'mp3',
//       'audio/ogg': 'ogg'
//     };
//     return formatMap[mimeType] || 'webm';
//   };

//   const startRecording = () => {
//     if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'inactive') {
//       audioChunksRef.current = [];
//       mediaRecorderRef.current.start();
//       setIsRecording(true);
//       setTempRecording(null);
//       setHasListenedToRecording(false);
//     }
//   };

//   const stopRecording = () => {
//     if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
//       mediaRecorderRef.current.stop();
//       setIsRecording(false);
//     }
//   };

//   const playRecording = (audioUrl) => {
//     if (audioUrl) {
//       const audio = new Audio(audioUrl);
//       audio.play();
//       setHasListenedToRecording(true);
//     }
//   };

//   const getUnrecordedSyllables = useCallback(() => {
//     return hangulSyllables
//       .map((syllable, index) => ({ syllable, originalIndex: index }))
//       .filter(({ syllable }) => !recordings[syllable] || !recordings[syllable].saved);
//   }, [hangulSyllables, recordings]);

//   const saveRecording = async () => {
//     if (tempRecording && !isSaving && hasListenedToRecording) {
//       setIsSaving(true);
//       const syllable = hangulSyllables[currentSyllableIndex];
      
//       try {
//         const base64Audio = await blobToBase64(tempRecording.blob);
//         const audioFormat = getAudioFormatFromBlob(tempRecording.blob);
        
//         await apiService.current.saveProfessionalSyllableRecording({
//           syllable,
//           audio_data: base64Audio,
//           language: 'KR',
//           audio_format: audioFormat,
//           speaker
//         });
        
//         setRecordings(prev => ({
//           ...prev,
//           [syllable]: { ...tempRecording, saved: true }
//         }));
//         setTempRecording(null);
//         setHasListenedToRecording(false);
        
//         if (recordMode === 'unrecorded') {
//           const unrecordedSyllables = getUnrecordedSyllables();
//           const currentUnrecordedIndex = unrecordedSyllables.findIndex(
//             ({ originalIndex }) => originalIndex === currentSyllableIndex
//           );
//           if (currentUnrecordedIndex < unrecordedSyllables.length - 1) {
//             const nextUnrecorded = unrecordedSyllables[currentUnrecordedIndex + 1];
//             setCurrentSyllableIndex(nextUnrecorded.originalIndex);
//           }
//         } else {
//           if (currentSyllableIndex < hangulSyllables.length - 1) {
//             setCurrentSyllableIndex(currentSyllableIndex + 1);
//           }
//         }
//       } catch (error) {
//         console.error('Error saving recording:', error);
//         alert('Failed to save recording. Please try again.');
//       } finally {
//         setIsSaving(false);
//       }
//     }
//   };

//   const goToRecordSyllable = (syllableIndex) => {
//     setCurrentSyllableIndex(syllableIndex);
//     setCurrentPage('recorder');
//     setHasListenedToRecording(false);
//   };

//   if (!isLoggedIn) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 p-8 flex items-center justify-center">
//         <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full">
//           <div className="text-center mb-8">
//             <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
//               <User className="w-10 h-10 text-purple-600" />
//             </div>
//             <h1 className="text-2xl font-bold text-gray-800">Korean Syllable Recorder</h1>
//             <p className="text-gray-600 mt-2">Enter your name to start recording</p>
//           </div>
          
//           <div className="space-y-4">
//             <input
//               type="text"
//               placeholder="Your name (e.g., john, speaker1)"
//               value={speakerInput}
//               onChange={(e) => setSpeakerInput(e.target.value)}
//               onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600 text-lg"
//             />
//             <button
//               onClick={handleLogin}
//               disabled={!speakerInput.trim()}
//               className="w-full px-4 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition disabled:opacity-50 disabled:cursor-not-allowed text-lg font-semibold"
//             >
//               Start Recording
//             </button>
//           </div>
          
//           <p className="text-sm text-gray-500 mt-6 text-center">
//             Your recordings will be saved to your personal folder
//           </p>
//         </div>
//       </div>
//     );
//   }

//   if (loadingStatus || hangulSyllables.length === 0) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 p-8 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-purple-600 mx-auto mb-4"></div>
//           <h2 className="text-2xl font-semibold text-gray-700 mb-2">Loading Syllables...</h2>
//           <p className="text-gray-500">Loading recordings for <span className="font-semibold">{speaker}</span></p>
//         </div>
//       </div>
//     );
//   }

//   const completionPercentage = Math.round((Object.keys(recordings).length / hangulSyllables.length) * 100);
//   const filteredSyllables = searchTerm 
//     ? hangulSyllables.filter(syllable => syllable.includes(searchTerm))
//     : hangulSyllables;

//   const SpeakerHeader = () => (
//     <div className="bg-white rounded-xl shadow-md p-4 mb-6 flex items-center justify-between">
//       <div className="flex items-center gap-3">
//         <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
//           <User className="w-5 h-5 text-purple-600" />
//         </div>
//         <div>
//           <p className="text-sm text-gray-500">Recording as</p>
//           <p className="font-semibold text-gray-800">{speaker}</p>
//         </div>
//       </div>
//       <div className="flex items-center gap-4">
//         <div className="text-right">
//           <p className="text-sm text-gray-500">Progress</p>
//           <p className="font-semibold text-purple-600">{Object.keys(recordings).length} / {hangulSyllables.length}</p>
//         </div>
//         <button
//           onClick={handleLogout}
//           className="p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition"
//           title="Switch speaker"
//         >
//           <LogOut className="w-5 h-5" />
//         </button>
//       </div>
//     </div>
//   );

//   if (currentPage === 'recorder') {
//     const unrecordedSyllables = getUnrecordedSyllables();
//     const allRecorded = unrecordedSyllables.length === 0;
    
//     let currentSyllable, displayIndex, totalInMode;
    
//     if (recordMode === 'unrecorded' && !allRecorded) {
//       const currentUnrecordedIndex = unrecordedSyllables.findIndex(
//         ({ originalIndex }) => originalIndex === currentSyllableIndex
//       );
      
//       const effectiveIndex = currentUnrecordedIndex === -1 ? 0 : currentUnrecordedIndex;
//       const currentUnrecordedSyllable = unrecordedSyllables[effectiveIndex];
//       currentSyllable = currentUnrecordedSyllable.syllable;
//       const actualCurrentIndex = currentUnrecordedSyllable.originalIndex;
      
//       if (actualCurrentIndex !== currentSyllableIndex) {
//         setCurrentSyllableIndex(actualCurrentIndex);
//       }
      
//       displayIndex = effectiveIndex;
//       totalInMode = unrecordedSyllables.length;
//     } else {
//       currentSyllable = hangulSyllables[currentSyllableIndex];
//       displayIndex = currentSyllableIndex;
//       totalInMode = hangulSyllables.length;
//     }

//     const hasExistingRecording = recordings[currentSyllable] && recordings[currentSyllable].saved;

//     const goToPrevious = () => {
//       if (recordMode === 'unrecorded' && !allRecorded) {
//         const currentUnrecordedIndex = unrecordedSyllables.findIndex(
//           ({ originalIndex }) => originalIndex === currentSyllableIndex
//         );
//         if (currentUnrecordedIndex > 0) {
//           const prevUnrecorded = unrecordedSyllables[currentUnrecordedIndex - 1];
//           setCurrentSyllableIndex(prevUnrecorded.originalIndex);
//           setHasListenedToRecording(false);
//         }
//       } else {
//         if (currentSyllableIndex > 0) {
//           setCurrentSyllableIndex(currentSyllableIndex - 1);
//           setHasListenedToRecording(false);
//         }
//       }
//     };

//     const goToNext = () => {
//       if (recordMode === 'unrecorded' && !allRecorded) {
//         const currentUnrecordedIndex = unrecordedSyllables.findIndex(
//           ({ originalIndex }) => originalIndex === currentSyllableIndex
//         );
//         if (currentUnrecordedIndex < unrecordedSyllables.length - 1) {
//           const nextUnrecorded = unrecordedSyllables[currentUnrecordedIndex + 1];
//           setCurrentSyllableIndex(nextUnrecorded.originalIndex);
//           setHasListenedToRecording(false);
//         }
//       } else {
//         if (currentSyllableIndex < hangulSyllables.length - 1) {
//           setCurrentSyllableIndex(currentSyllableIndex + 1);
//           setHasListenedToRecording(false);
//         }
//       }
//     };

//     return (
//       <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 p-8">
//         <div className="max-w-2xl mx-auto">
//           <SpeakerHeader />
          
//           <div className="mb-6 flex justify-between items-center">
//             <h1 className="text-3xl font-bold text-gray-800">Korean Syllable Recorder</h1>
//             <button
//               onClick={() => setCurrentPage('summary')}
//               className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition"
//             >
//               View Summary
//             </button>
//           </div>

//           <div className="bg-white rounded-xl shadow-md p-4 mb-6">
//             <div className="flex items-center justify-between">
//               <div className="flex gap-2">
//                 <button
//                   onClick={() => {
//                     setRecordMode('unrecorded');
//                     if (unrecordedSyllables.length > 0) {
//                       setCurrentSyllableIndex(unrecordedSyllables[0].originalIndex);
//                     }
//                   }}
//                   disabled={allRecorded}
//                   className={`px-4 py-2 rounded-lg transition ${
//                     recordMode === 'unrecorded' && !allRecorded
//                       ? 'bg-purple-600 text-white' 
//                       : allRecorded 
//                         ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
//                         : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
//                   }`}
//                 >
//                   Unrecorded Only {!allRecorded && `(${unrecordedSyllables.length})`}
//                 </button>
//                 <button
//                   onClick={() => setRecordMode('all')}
//                   className={`px-4 py-2 rounded-lg transition ${
//                     recordMode === 'all' || allRecorded
//                       ? 'bg-purple-600 text-white' 
//                       : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
//                   }`}
//                 >
//                   All Syllables ({hangulSyllables.length})
//                 </button>
//               </div>
//               <div className="text-sm text-gray-600">
//                 {completionPercentage}% Complete
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-2xl shadow-xl p-8">
//             <div className="text-center mb-8">
//               <p className="text-gray-600 mb-2">
//                 {recordMode === 'unrecorded' && !allRecorded ? 'Unrecorded' : ''} Syllable {displayIndex + 1} of {totalInMode}
//                 {recordMode === 'unrecorded' && !allRecorded && (
//                   <span className="text-sm text-gray-500 block mt-1">
//                     (#{currentSyllableIndex + 1} of {hangulSyllables.length} total)
//                   </span>
//                 )}
//               </p>
//               <div className="text-8xl font-bold text-gray-800 mb-4">{currentSyllable}</div>
//               {hasExistingRecording ? (
//                 <div className="text-sm text-green-600 bg-green-50 px-3 py-1 rounded-full inline-block">
//                   ✓ Already recorded
//                 </div>
//               ) : (
//                 <div className="text-sm text-blue-600 bg-blue-50 px-3 py-1 rounded-full inline-block">
//                   Not yet recorded
//                 </div>
//               )}
//             </div>

//             <div className="space-y-6">
//               <div className="border-2 border-gray-200 rounded-lg p-6">
//                 <h3 className="text-lg font-semibold text-gray-700 mb-4 text-center">
//                   {hasExistingRecording ? 'New Recording (will replace existing)' : 'New Recording'}
//                 </h3>
                
//                 <div className="flex justify-center gap-4 mb-4">
//                   {!isRecording ? (
//                     <button
//                       onClick={startRecording}
//                       className="flex items-center gap-2 px-6 py-3 bg-red-500 text-white rounded-full hover:bg-red-600 transition shadow-lg"
//                     >
//                       <Mic className="w-5 h-5" />
//                       Start Recording
//                     </button>
//                   ) : (
//                     <button
//                       onClick={stopRecording}
//                       className="flex items-center gap-2 px-6 py-3 bg-gray-700 text-white rounded-full hover:bg-gray-800 transition shadow-lg animate-pulse"
//                     >
//                       <Square className="w-5 h-5" />
//                       Stop Recording
//                     </button>
//                   )}
//                 </div>

//                 {tempRecording && (
//                   <div className="space-y-4 p-4 bg-gray-50 rounded-lg">
//                     <p className="text-sm text-gray-600 text-center">Your new recording (not saved yet):</p>
                    
//                     {!hasListenedToRecording && (
//                       <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 text-center">
//                         <p className="text-sm text-yellow-700 font-medium">
//                           ⚠️ Please listen to your recording before saving
//                         </p>
//                       </div>
//                     )}
                    
//                     <div className="flex justify-center gap-4">
//                       <button
//                         onClick={() => playRecording(tempRecording.url)}
//                         className={`flex items-center gap-2 px-4 py-2 rounded-lg transition ${
//                           hasListenedToRecording 
//                             ? 'bg-blue-500 text-white hover:bg-blue-600' 
//                             : 'bg-blue-600 text-white hover:bg-blue-700 ring-2 ring-blue-300 animate-pulse'
//                         }`}
//                       >
//                         <Play className="w-4 h-4" />
//                         {hasListenedToRecording ? 'Play Again' : 'Play Your Recording'}
//                       </button>
//                       <button
//                         onClick={saveRecording}
//                         disabled={isSaving || !hasListenedToRecording}
//                         className={`flex items-center gap-2 px-4 py-2 rounded-lg transition ${
//                           hasListenedToRecording 
//                             ? 'bg-green-500 text-white hover:bg-green-600' 
//                             : 'bg-gray-300 text-gray-500 cursor-not-allowed'
//                         } disabled:opacity-50`}
//                         title={!hasListenedToRecording ? 'Please listen to your recording first' : ''}
//                       >
//                         <Save className="w-4 h-4" />
//                         {isSaving ? 'Saving...' : hasExistingRecording ? 'Replace Recording' : 'Save Recording'}
//                       </button>
//                     </div>
                    
//                     {hasListenedToRecording && (
//                       <div className="bg-green-50 border border-green-200 rounded-lg p-3 text-center">
//                         <p className="text-sm text-green-700">
//                           ✓ Recording reviewed - ready to save!
//                         </p>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               {hasExistingRecording && (
//                 <div className="border-2 border-green-200 rounded-lg p-6 bg-green-50">
//                   <h3 className="text-lg font-semibold text-green-700 mb-4 text-center">Currently Saved Recording</h3>
//                   <div className="flex justify-center">
//                     <button
//                       onClick={() => playCloudRecording(currentSyllable)}
//                       className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition shadow"
//                     >
//                       <Play className="w-5 h-5" />
//                       Play Saved Recording
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="flex justify-between mt-8">
//               <button
//                 onClick={goToPrevious}
//                 disabled={displayIndex === 0}
//                 className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 Previous {recordMode === 'unrecorded' && !allRecorded ? 'Unrecorded' : ''}
//               </button>
//               <button
//                 onClick={goToNext}
//                 disabled={displayIndex === totalInMode - 1}
//                 className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 Next {recordMode === 'unrecorded' && !allRecorded ? 'Unrecorded' : ''}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 p-8">
//       <div className="max-w-6xl mx-auto">
//         <SpeakerHeader />
        
//         <div className="mb-6 flex justify-between items-center">
//           <h1 className="text-3xl font-bold text-gray-800">Recording Summary</h1>
//           <button
//             onClick={() => setCurrentPage('recorder')}
//             className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition"
//           >
//             Back to Recorder
//           </button>
//         </div>

//         <div className="bg-white rounded-2xl shadow-xl p-6 mb-6">
//           <div className="text-center">
//             <h2 className="text-xl font-semibold text-gray-700 mb-2">Progress</h2>
//             <div className="text-4xl font-bold text-purple-600">{completionPercentage}%</div>
//             <p className="text-gray-600 mt-1">
//               {Object.keys(recordings).length} of {hangulSyllables.length} syllables recorded
//             </p>
//             <div className="w-full bg-gray-200 rounded-full h-3 mt-4">
//               <div 
//                 className="bg-purple-600 h-3 rounded-full transition-all duration-300"
//                 style={{ width: `${completionPercentage}%` }}
//               />
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl shadow-xl p-6">
//           <div className="mb-4 flex items-center justify-between">
//             <div className="relative flex-1 mr-4">
//               <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
//               <input
//                 type="text"
//                 placeholder="Search syllables..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
//               />
//             </div>
//             <span className="text-gray-500 text-sm">
//               {hangulSyllables.length} syllables loaded
//             </span>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead>
//                 <tr className="border-b bg-gray-50">
//                   <th className="text-left py-3 px-4 font-semibold">Syllable</th>
//                   <th className="text-center py-3 px-4 font-semibold">Status</th>
//                   <th className="text-center py-3 px-4 font-semibold">Play</th>
//                   <th className="text-center py-3 px-4 font-semibold">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredSyllables.map((syllable) => {
//                   const syllableIndex = hangulSyllables.indexOf(syllable);
//                   const hasRecording = recordings[syllable] && recordings[syllable].saved;
                  
//                   return (
//                     <tr key={syllable} className="border-b hover:bg-gray-50 transition-colors">
//                       <td className="py-4 px-4">
//                         <button
//                           onClick={() => goToRecordSyllable(syllableIndex)}
//                           className="text-3xl font-bold hover:text-purple-600 transition-colors cursor-pointer"
//                           title="Click to record this syllable"
//                         >
//                           {syllable}
//                         </button>
//                       </td>
//                       <td className="py-4 px-4 text-center">
//                         {hasRecording ? (
//                           <span className="inline-flex items-center text-green-600 bg-green-50 px-3 py-1 rounded-full text-sm">
//                             <Check className="w-4 h-4 mr-1" />
//                             Recorded
//                           </span>
//                         ) : (
//                           <span className="text-gray-400 bg-gray-100 px-3 py-1 rounded-full text-sm">
//                             Not recorded
//                           </span>
//                         )}
//                       </td>
//                       <td className="py-4 px-4 text-center">
//                         {hasRecording ? (
//                           <button
//                             onClick={() => playCloudRecording(syllable)}
//                             className="p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition shadow-sm hover:shadow-md"
//                             title="Play recording"
//                           >
//                             <Play className="w-5 h-5" />
//                           </button>
//                         ) : (
//                           <span className="p-2 text-gray-300">
//                             <Play className="w-5 h-5" />
//                           </span>
//                         )}
//                       </td>
//                       <td className="py-4 px-4 text-center">
//                         <button
//                           onClick={() => goToRecordSyllable(syllableIndex)}
//                           className={`px-4 py-2 rounded-lg transition ${
//                             hasRecording 
//                               ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' 
//                               : 'bg-purple-600 text-white hover:bg-purple-700'
//                           }`}
//                         >
//                           {hasRecording ? 'Re-record' : 'Record'}
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>

//           {filteredSyllables.length === 0 && (
//             <div className="text-center py-8 text-gray-500">
//               No syllables found matching "{searchTerm}"
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default KoreanSyllableRecorder;








// import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { Mic, Square, Play, Save, Search, Check, User, LogOut, AlertTriangle } from 'lucide-react';
// import ApiService from '../ApiService';

// const MIN_VALID_AUDIO_SIZE = 500; // Minimum bytes for a valid audio recording

// const KoreanSyllableRecorder = () => {
//   const [currentPage, setCurrentPage] = useState('recorder');
//   const [recordings, setRecordings] = useState({});
//   const [hangulSyllables, setHangulSyllables] = useState([]);
//   const [currentSyllableIndex, setCurrentSyllableIndex] = useState(0);
//   const [isRecording, setIsRecording] = useState(false);
//   const [tempRecording, setTempRecording] = useState(null);
//   const [hasListenedToRecording, setHasListenedToRecording] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [isSaving, setIsSaving] = useState(false);
//   const [loadingStatus, setLoadingStatus] = useState(false);
//   const [recordMode, setRecordMode] = useState('unrecorded');
//   const [recordingError, setRecordingError] = useState(null);
//   const [micStatus, setMicStatus] = useState('initializing');
//   const [verificationStatus, setVerificationStatus] = useState(null); // null, 'verifying', 'success', 'failed'
//   const [verifiedAudioUrl, setVerifiedAudioUrl] = useState(null);
//   const [verifiedFileSize, setVerifiedFileSize] = useState(null);
  
//   const [speaker, setSpeaker] = useState('');
//   const [speakerInput, setSpeakerInput] = useState('');
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
  
//   const mediaRecorderRef = useRef(null);
//   const audioChunksRef = useRef([]);
//   const streamRef = useRef(null);
//   const apiService = useRef(new ApiService());

//   const initializeMicrophone = useCallback(async () => {
//     try {
//       setMicStatus('initializing');
//       setRecordingError(null);

//       // Clean up old stream
//       if (streamRef.current) {
//         streamRef.current.getTracks().forEach(track => track.stop());
//       }

//       const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//       streamRef.current = stream;

//       const mediaRecorder = new MediaRecorder(stream, {
//         mimeType: MediaRecorder.isTypeSupported('audio/webm;codecs=opus')
//           ? 'audio/webm;codecs=opus'
//           : 'audio/webm'
//       });
//       mediaRecorderRef.current = mediaRecorder;
      
//       mediaRecorder.ondataavailable = (event) => {
//         if (event.data && event.data.size > 0) {
//           audioChunksRef.current.push(event.data);
//         }
//       };
      
//       mediaRecorder.onstop = () => {
//         if (audioChunksRef.current.length === 0) {
//           setRecordingError('No audio data was captured. Please check your microphone and try again.');
//           setTempRecording(null);
//           audioChunksRef.current = [];
//           return;
//         }

//         const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
//         console.log(`Recording complete: ${audioChunksRef.current.length} chunks, ${audioBlob.size} bytes`);

//         if (audioBlob.size < MIN_VALID_AUDIO_SIZE) {
//           setRecordingError(
//             `Recording too small (${audioBlob.size} bytes). Your microphone may not be capturing audio. Please check your mic settings and try again.`
//           );
//           setTempRecording(null);
//           audioChunksRef.current = [];
//           return;
//         }

//         const audioUrl = URL.createObjectURL(audioBlob);
//         setTempRecording({ blob: audioBlob, url: audioUrl, size: audioBlob.size });
//         setHasListenedToRecording(false);
//         setRecordingError(null);
//         audioChunksRef.current = [];
//       };

//       mediaRecorder.onerror = (event) => {
//         console.error('MediaRecorder error:', event.error);
//         setRecordingError(`Recording error: ${event.error?.message || 'Unknown error'}`);
//         setIsRecording(false);
//       };

//       // Listen for track ending (mic disconnected)
//       stream.getAudioTracks().forEach(track => {
//         track.addEventListener('ended', () => {
//           setMicStatus('error');
//           setRecordingError('Microphone was disconnected. Click "Reinitialize Microphone" to reconnect.');
//           setIsRecording(false);
//         });
//       });

//       setMicStatus('ready');
//     } catch (err) {
//       console.error('Error accessing microphone:', err);
//       setMicStatus('error');
//       setRecordingError(`Could not access microphone: ${err.message}`);
//     }
//   }, []);

//   // Validate that the audio stream is actually active
//   const validateStream = useCallback(() => {
//     if (!streamRef.current) {
//       setMicStatus('no-stream');
//       setRecordingError('No audio stream. Please reinitialize your microphone.');
//       return false;
//     }

//     const audioTracks = streamRef.current.getAudioTracks();
//     if (audioTracks.length === 0) {
//       setMicStatus('no-stream');
//       setRecordingError('No audio tracks found. Please check your microphone.');
//       return false;
//     }

//     const track = audioTracks[0];
//     if (track.readyState !== 'live' || track.muted) {
//       setMicStatus('error');
//       setRecordingError(`Microphone issue: track is ${track.readyState}${track.muted ? ' (muted)' : ''}. Please reconnect your microphone.`);
//       return false;
//     }

//     return true;
//   }, []);

//   const loadRecordingsStatus = useCallback(async () => {
//     if (!speaker) return;
    
//     try {
//       setLoadingStatus(true);
//       const status = await apiService.current.getSyllableRecordingsStatus({ 
//         language: 'KR', 
//         speaker: speaker 
//       });
//       console.log('status: ', status);
      
//       const syllables = Object.keys(status);
//       setHangulSyllables(syllables);
      
//       const formattedRecordings = {};
//       Object.entries(status).forEach(([syllable, exists]) => {
//         if (exists) {
//           formattedRecordings[syllable] = { saved: true };
//         }
//       });
//       setRecordings(formattedRecordings);
      
//       const allRecorded = syllables.every(syllable => formattedRecordings[syllable]?.saved);
//       if (allRecorded) {
//         setRecordMode('all');
//       } else {
//         // Jump to first unrecorded syllable on load
//         const firstUnrecordedIndex = syllables.findIndex(
//           syllable => !formattedRecordings[syllable]?.saved
//         );
//         if (firstUnrecordedIndex !== -1) {
//           setCurrentSyllableIndex(firstUnrecordedIndex);
//         }
//       }
//     } catch (error) {
//       console.error('Error loading recordings status:', error);
//       setHangulSyllables([]);
//     } finally {
//       setLoadingStatus(false);
//     }
//   }, [speaker]);

//   useEffect(() => {
//     const savedSpeaker = localStorage.getItem('syllableRecorderSpeaker');
//     if (savedSpeaker) {
//       setSpeaker(savedSpeaker);
//       setSpeakerInput(savedSpeaker);
//       setIsLoggedIn(true);
//     }
//   }, []);

//   useEffect(() => {
//     if (isLoggedIn && speaker) {
//       loadRecordingsStatus();
//       initializeMicrophone();
//     }

//     return () => {
//       if (streamRef.current) {
//         streamRef.current.getTracks().forEach(track => track.stop());
//       }
//     };
//   }, [isLoggedIn, speaker, loadRecordingsStatus, initializeMicrophone]);

//   const handleLogin = () => {
//     const trimmedName = speakerInput.trim().toLowerCase().replace(/\s+/g, '_');
//     if (trimmedName) {
//       setSpeaker(trimmedName);
//       localStorage.setItem('syllableRecorderSpeaker', trimmedName);
//       setIsLoggedIn(true);
//     }
//   };

//   const handleLogout = () => {
//     if (streamRef.current) {
//       streamRef.current.getTracks().forEach(track => track.stop());
//     }
//     setSpeaker('');
//     setSpeakerInput('');
//     setIsLoggedIn(false);
//     setHangulSyllables([]);
//     setRecordings({});
//     setVerificationStatus(null);
//     setVerifiedAudioUrl(null);
//     setVerifiedFileSize(null);
//     setRecordingError(null);
//     localStorage.removeItem('syllableRecorderSpeaker');
//   };

//   const playCloudRecording = async (syllable) => {
//     try {
//       const blob = await apiService.current.getProfessionalSyllableRecording({ 
//         syllable, 
//         format: 'webm',
//         speaker 
//       });
//       const audioUrl = URL.createObjectURL(blob);
//       const audio = new Audio(audioUrl);
      
//       audio.play();
//       audio.addEventListener('ended', () => {
//         URL.revokeObjectURL(audioUrl);
//       });
//     } catch (error) {
//       console.error('Error playing cloud recording:', error);
//       alert('Error playing recording. Please try again.');
//     }
//   };

//   const blobToBase64 = (blob) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         const base64String = reader.result.split(',')[1];
//         if (!base64String) {
//           reject(new Error('Base64 conversion failed: no data after split'));
//           return;
//         }
//         resolve(base64String);
//       };
//       reader.onerror = () => reject(new Error('FileReader error during base64 conversion'));
//       reader.readAsDataURL(blob);
//     });
//   };

//   const getAudioFormatFromBlob = (blob) => {
//     const mimeType = blob.type;
//     const formatMap = {
//       'audio/webm': 'webm',
//       'audio/wav': 'wav',
//       'audio/mpeg': 'mp3',
//       'audio/mp3': 'mp3',
//       'audio/ogg': 'ogg'
//     };
//     return formatMap[mimeType] || 'webm';
//   };

//   const startRecording = () => {
//     setRecordingError(null);
//     setVerificationStatus(null);
//     setVerifiedAudioUrl(null);
//     setVerifiedFileSize(null);

//     // Validate stream is still active before recording
//     if (!validateStream()) {
//       return;
//     }

//     if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'inactive') {
//       audioChunksRef.current = [];
//       try {
//         // Request data every 250ms to catch issues early
//         mediaRecorderRef.current.start(250);
//         setIsRecording(true);
//         setTempRecording(null);
//         setHasListenedToRecording(false);
//       } catch (err) {
//         console.error('Failed to start recording:', err);
//         setRecordingError(`Failed to start recording: ${err.message}. Try reinitializing the microphone.`);
//       }
//     } else if (mediaRecorderRef.current) {
//       setRecordingError(`MediaRecorder is in "${mediaRecorderRef.current.state}" state. Please wait or reinitialize.`);
//     } else {
//       setRecordingError('MediaRecorder not initialized. Please reinitialize the microphone.');
//     }
//   };

//   const stopRecording = () => {
//     if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
//       mediaRecorderRef.current.stop();
//       setIsRecording(false);
//     }
//   };

//   const playRecording = (audioUrl) => {
//     if (audioUrl) {
//       const audio = new Audio(audioUrl);
//       audio.play();
//       setHasListenedToRecording(true);
//     }
//   };

//   const getUnrecordedSyllables = useCallback(() => {
//     return hangulSyllables
//       .map((syllable, index) => ({ syllable, originalIndex: index }))
//       .filter(({ syllable }) => !recordings[syllable] || !recordings[syllable].saved);
//   }, [hangulSyllables, recordings]);

//   // Verify a recording by pulling it back from blob storage
//   const verifyRecordingFromStorage = async (syllable) => {
//     setVerificationStatus('verifying');
//     setVerifiedAudioUrl(null);
//     setVerifiedFileSize(null);

//     try {
//       const blob = await apiService.current.getProfessionalSyllableRecording({
//         syllable,
//         format: 'webm',
//         speaker
//       });

//       console.log(`🔍 Verification for "${syllable}": fetched ${blob.size} bytes from storage`);

//       if (!blob || blob.size < MIN_VALID_AUDIO_SIZE) {
//         throw new Error(`File in storage is too small (${blob?.size || 0} bytes). The upload may have failed.`);
//       }

//       const audioUrl = URL.createObjectURL(blob);
//       setVerifiedAudioUrl(audioUrl);
//       setVerifiedFileSize(blob.size);
//       setVerificationStatus('success');
//       return true;
//     } catch (error) {
//       console.error(`❌ Verification failed for "${syllable}":`, error);
//       setVerificationStatus('failed');
//       setRecordingError(`Verification failed: ${error.message}. Please refresh your browser and try again.`);
//       return false;
//     }
//   };

//   const playVerifiedRecording = () => {
//     if (verifiedAudioUrl) {
//       const audio = new Audio(verifiedAudioUrl);
//       audio.play();
//     }
//   };

//   // Advance to next syllable (called manually after successful verification)
//   // const advanceToNext = () => {
//   //   if (verifiedAudioUrl) {
//   //     URL.revokeObjectURL(verifiedAudioUrl);
//   //   }
//   //   setVerificationStatus(null);
//   //   setVerifiedAudioUrl(null);
//   //   setVerifiedFileSize(null);
//   //   setTempRecording(null);
//   //   setHasListenedToRecording(false);
//   //   setRecordingError(null);

//   //   if (recordMode === 'unrecorded') {
//   //     const unrecordedSyllables = getUnrecordedSyllables();
//   //     const currentUnrecordedIndex = unrecordedSyllables.findIndex(
//   //       ({ originalIndex }) => originalIndex === currentSyllableIndex
//   //     );
//   //     if (currentUnrecordedIndex < unrecordedSyllables.length - 1) {
//   //       const nextUnrecorded = unrecordedSyllables[currentUnrecordedIndex + 1];
//   //       setCurrentSyllableIndex(nextUnrecorded.originalIndex);
//   //     }
//   //   } else {
//   //     if (currentSyllableIndex < hangulSyllables.length - 1) {
//   //       setCurrentSyllableIndex(currentSyllableIndex + 1);
//   //     }
//   //   }
//   // };

//   const saveRecording = async () => {
//     if (!tempRecording || isSaving || !hasListenedToRecording) return;

//     // Validate blob size before saving
//     if (!tempRecording.blob || tempRecording.blob.size < MIN_VALID_AUDIO_SIZE) {
//       setRecordingError(
//         `Cannot save: recording is too small (${tempRecording.blob?.size || 0} bytes). Please re-record.`
//       );
//       return;
//     }

//     setIsSaving(true);
//     setRecordingError(null);
//     setVerificationStatus(null);
//     setVerifiedAudioUrl(null);
//     setVerifiedFileSize(null);
//     const syllable = hangulSyllables[currentSyllableIndex];
    
//     try {
//       const base64Audio = await blobToBase64(tempRecording.blob);

//       // Validate base64 isn't empty
//       if (!base64Audio || base64Audio.length < 100) {
//         throw new Error(`Base64 conversion produced insufficient data: ${base64Audio?.length || 0} chars`);
//       }

//       const audioFormat = getAudioFormatFromBlob(tempRecording.blob);
      
//       await apiService.current.saveProfessionalSyllableRecording({
//         syllable,
//         audio_data: base64Audio,
//         language: 'KR',
//         audio_format: audioFormat,
//         speaker
//       });

//       console.log(`✅ Saved "${syllable}": ${tempRecording.blob.size} bytes`);
      
//       setRecordings(prev => ({
//         ...prev,
//         [syllable]: { ...tempRecording, saved: true }
//       }));

//       // Now verify by pulling it back from storage
//       setIsSaving(false);
//       const verified = await verifyRecordingFromStorage(syllable);

//       if (!verified) {
//         // Revert the local saved status since verification failed
//         setRecordings(prev => {
//           const updated = { ...prev };
//           delete updated[syllable];
//           return updated;
//         });
//       }
//     } catch (error) {
//       console.error('Error saving recording:', error);
//       setRecordingError(`Failed to save: ${error.message}`);
//       setIsSaving(false);
//     }
//   };

//   const resetVerificationState = () => {
//     if (verifiedAudioUrl) URL.revokeObjectURL(verifiedAudioUrl);
//     setVerificationStatus(null);
//     setVerifiedAudioUrl(null);
//     setVerifiedFileSize(null);
//     setTempRecording(null);
//     setRecordingError(null);
//   };

//   const goToRecordSyllable = (syllableIndex) => {
//     resetVerificationState();
//     setCurrentSyllableIndex(syllableIndex);
//     setCurrentPage('recorder');
//     setHasListenedToRecording(false);
//   };

//   // Login screen
//   if (!isLoggedIn) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 p-8 flex items-center justify-center">
//         <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full">
//           <div className="text-center mb-8">
//             <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
//               <User className="w-10 h-10 text-purple-600" />
//             </div>
//             <h1 className="text-2xl font-bold text-gray-800">Korean Syllable Recorder</h1>
//             <p className="text-gray-600 mt-2">Enter your name to start recording</p>
//           </div>
          
//           <div className="space-y-4">
//             <input
//               type="text"
//               placeholder="Your name (e.g., john, speaker1)"
//               value={speakerInput}
//               onChange={(e) => setSpeakerInput(e.target.value)}
//               onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600 text-lg"
//             />
//             <button
//               onClick={handleLogin}
//               disabled={!speakerInput.trim()}
//               className="w-full px-4 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition disabled:opacity-50 disabled:cursor-not-allowed text-lg font-semibold"
//             >
//               Start Recording
//             </button>
//           </div>
          
//           <p className="text-sm text-gray-500 mt-6 text-center">
//             Your recordings will be saved to your personal folder
//           </p>
//         </div>
//       </div>
//     );
//   }

//   // Loading screen
//   if (loadingStatus || hangulSyllables.length === 0) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 p-8 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-purple-600 mx-auto mb-4"></div>
//           <h2 className="text-2xl font-semibold text-gray-700 mb-2">Loading Syllables...</h2>
//           <p className="text-gray-500">Loading recordings for <span className="font-semibold">{speaker}</span></p>
//         </div>
//       </div>
//     );
//   }

//   const completionPercentage = Math.round((Object.keys(recordings).length / hangulSyllables.length) * 100);
//   const filteredSyllables = searchTerm 
//     ? hangulSyllables.filter(syllable => syllable.includes(searchTerm))
//     : hangulSyllables;

//   const SpeakerHeader = () => (
//     <div className="bg-white rounded-xl shadow-md p-4 mb-6 flex items-center justify-between">
//       <div className="flex items-center gap-3">
//         <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
//           <User className="w-5 h-5 text-purple-600" />
//         </div>
//         <div>
//           <p className="text-sm text-gray-500">Recording as</p>
//           <p className="font-semibold text-gray-800">{speaker}</p>
//         </div>
//       </div>
//       <div className="flex items-center gap-4">
//         <div className="text-right">
//           <p className="text-sm text-gray-500">Progress</p>
//           <p className="font-semibold text-purple-600">{Object.keys(recordings).length} / {hangulSyllables.length}</p>
//         </div>
//         <button
//           onClick={handleLogout}
//           className="p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition"
//           title="Switch speaker"
//         >
//           <LogOut className="w-5 h-5" />
//         </button>
//       </div>
//     </div>
//   );

//   // Mic status / error banner
//   const StatusBanner = () => {
//     if (micStatus === 'ready' && !recordingError) return null;

//     const isError = micStatus === 'error' || micStatus === 'no-stream';

//     return (
//       <div className={`mb-4 p-3 rounded-lg flex items-center justify-between ${
//         isError
//           ? 'bg-red-50 border border-red-200'
//           : recordingError
//             ? 'bg-yellow-50 border border-yellow-200'
//             : 'bg-blue-50 border border-blue-200'
//       }`}>
//         <div className="flex items-center gap-2">
//           <AlertTriangle className={`w-5 h-5 ${isError ? 'text-red-500' : 'text-yellow-500'}`} />
//           <span className={`text-sm ${isError ? 'text-red-700' : 'text-yellow-700'}`}>
//             {recordingError || (micStatus === 'initializing' ? 'Initializing microphone...' : 'Microphone unavailable')}
//           </span>
//         </div>
//         {isError && (
//           <button
//             onClick={initializeMicrophone}
//             className="px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-700 transition whitespace-nowrap ml-2"
//           >
//             Reinitialize Microphone
//           </button>
//         )}
//       </div>
//     );
//   };

//   // Verification result UI
//   const VerificationBlock = () => {
//     if (!verificationStatus) return null;

//     return (
//       <div className="mt-6">
//         {verificationStatus === 'verifying' && (
//           <div className="flex items-center gap-3 p-4 bg-blue-50 border border-blue-200 rounded-lg">
//             <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
//             <div>
//               <p className="text-sm font-medium text-blue-800">Verifying upload...</p>
//               <p className="text-xs text-blue-600">Pulling file back from storage to confirm it saved correctly.</p>
//             </div>
//           </div>
//         )}

//         {verificationStatus === 'success' && (
//           <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
//             <div className="flex items-center gap-2 mb-2">
//               <Check className="w-5 h-5 text-green-600" />
//               <p className="text-sm font-medium text-green-800">
//                 ✅ File verified! ({(verifiedFileSize / 1024).toFixed(1)} KB in storage)
//               </p>
//             </div>
//             <p className="text-xs text-green-600 mb-3">
//               Successfully pulled the file back from blob storage and confirmed it's valid.
//             </p>
//             <div className="flex gap-2">
//               <button
//                 onClick={playVerifiedRecording}
//                 className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
//               >
//                 <Play className="w-4 h-4" /> Play Verified File from Storage
//               </button>
//             </div>
//           </div>
//         )}

//         {verificationStatus === 'failed' && (
//           <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
//             <div className="flex items-center gap-2 mb-2">
//               <AlertTriangle className="w-5 h-5 text-red-600" />
//               <p className="text-sm font-medium text-red-800">
//                 ❌ Verification failed!
//               </p>
//             </div>
//             <p className="text-xs text-red-600 mb-3">
//               Could not retrieve a valid file from storage. The upload may have failed or the file is empty.
//             </p>
//             <div className="flex gap-2">
//               <button
//                 onClick={() => {
//                   setVerificationStatus(null);
//                   setRecordingError(null);
//                 }}
//                 className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
//               >
//                 Try Recording Again
//               </button>
//               <button
//                 onClick={() => window.location.reload()}
//                 className="flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition"
//               >
//                 Refresh Browser
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };

//   // Recorder Page
//   if (currentPage === 'recorder') {
//     const unrecordedSyllables = getUnrecordedSyllables();
//     const allRecorded = unrecordedSyllables.length === 0;
    
//     let currentSyllable, displayIndex, totalInMode;
    
//     if (recordMode === 'unrecorded' && !allRecorded) {
//       const currentUnrecordedIndex = unrecordedSyllables.findIndex(
//         ({ originalIndex }) => originalIndex === currentSyllableIndex
//       );
      
//       if (currentUnrecordedIndex === -1) {
//         // Current syllable was just recorded — stay on it if we're verifying/saving,
//         // otherwise show it using the "all" mode display so we don't snap away
//         currentSyllable = hangulSyllables[currentSyllableIndex];
//         displayIndex = currentSyllableIndex;
//         totalInMode = hangulSyllables.length;
//       } else {
//         const currentUnrecordedSyllable = unrecordedSyllables[currentUnrecordedIndex];
//         currentSyllable = currentUnrecordedSyllable.syllable;
//         displayIndex = currentUnrecordedIndex;
//         totalInMode = unrecordedSyllables.length;
//       }
//     } else {
//       currentSyllable = hangulSyllables[currentSyllableIndex];
//       displayIndex = currentSyllableIndex;
//       totalInMode = hangulSyllables.length;
//     }

//     const hasExistingRecording = recordings[currentSyllable] && recordings[currentSyllable].saved;

//     const goToPrevious = () => {
//       resetVerificationState();
//       if (recordMode === 'unrecorded' && !allRecorded) {
//         const currentUnrecordedIndex = unrecordedSyllables.findIndex(
//           ({ originalIndex }) => originalIndex === currentSyllableIndex
//         );
//         if (currentUnrecordedIndex > 0) {
//           const prevUnrecorded = unrecordedSyllables[currentUnrecordedIndex - 1];
//           setCurrentSyllableIndex(prevUnrecorded.originalIndex);
//           setHasListenedToRecording(false);
//         }
//       } else {
//         if (currentSyllableIndex > 0) {
//           setCurrentSyllableIndex(currentSyllableIndex - 1);
//           setHasListenedToRecording(false);
//         }
//       }
//     };

//     const goToNext = () => {
//       resetVerificationState();
//       if (recordMode === 'unrecorded' && !allRecorded) {
//         const currentUnrecordedIndex = unrecordedSyllables.findIndex(
//           ({ originalIndex }) => originalIndex === currentSyllableIndex
//         );
//         if (currentUnrecordedIndex < unrecordedSyllables.length - 1) {
//           const nextUnrecorded = unrecordedSyllables[currentUnrecordedIndex + 1];
//           setCurrentSyllableIndex(nextUnrecorded.originalIndex);
//           setHasListenedToRecording(false);
//         }
//       } else {
//         if (currentSyllableIndex < hangulSyllables.length - 1) {
//           setCurrentSyllableIndex(currentSyllableIndex + 1);
//           setHasListenedToRecording(false);
//         }
//       }
//     };

//     return (
//       <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 p-8">
//         <div className="max-w-2xl mx-auto">
//           <SpeakerHeader />

//           <StatusBanner />
          
//           <div className="mb-6 flex justify-between items-center">
//             <h1 className="text-3xl font-bold text-gray-800">Korean Syllable Recorder</h1>
//             <button
//               onClick={() => setCurrentPage('summary')}
//               className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition"
//             >
//               View Summary
//             </button>
//           </div>

//           <div className="bg-white rounded-xl shadow-md p-4 mb-6">
//             <div className="flex items-center justify-between">
//               <div className="flex gap-2">
//                 <button
//                   onClick={() => {
//                     setRecordMode('unrecorded');
//                     if (unrecordedSyllables.length > 0) {
//                       setCurrentSyllableIndex(unrecordedSyllables[0].originalIndex);
//                     }
//                   }}
//                   disabled={allRecorded}
//                   className={`px-4 py-2 rounded-lg transition ${
//                     recordMode === 'unrecorded' && !allRecorded
//                       ? 'bg-purple-600 text-white' 
//                       : allRecorded 
//                         ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
//                         : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
//                   }`}
//                 >
//                   Unrecorded Only {!allRecorded && `(${unrecordedSyllables.length})`}
//                 </button>
//                 <button
//                   onClick={() => setRecordMode('all')}
//                   className={`px-4 py-2 rounded-lg transition ${
//                     recordMode === 'all' || allRecorded
//                       ? 'bg-purple-600 text-white' 
//                       : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
//                   }`}
//                 >
//                   All Syllables ({hangulSyllables.length})
//                 </button>
//               </div>
//               <div className="text-sm text-gray-600">
//                 {completionPercentage}% Complete
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-2xl shadow-xl p-8">
//             <div className="text-center mb-8">
//               <p className="text-gray-600 mb-2">
//                 {recordMode === 'unrecorded' && !allRecorded ? 'Unrecorded' : ''} Syllable {displayIndex + 1} of {totalInMode}
//                 {recordMode === 'unrecorded' && !allRecorded && (
//                   <span className="text-sm text-gray-500 block mt-1">
//                     (#{currentSyllableIndex + 1} of {hangulSyllables.length} total)
//                   </span>
//                 )}
//               </p>
//               <div className="text-8xl font-bold text-gray-800 mb-4">{currentSyllable}</div>
//               {hasExistingRecording ? (
//                 <div className="text-sm text-green-600 bg-green-50 px-3 py-1 rounded-full inline-block">
//                   ✓ Already recorded
//                 </div>
//               ) : (
//                 <div className="text-sm text-blue-600 bg-blue-50 px-3 py-1 rounded-full inline-block">
//                   Not yet recorded
//                 </div>
//               )}
//             </div>

//             <div className="space-y-6">
//               <div className="border-2 border-gray-200 rounded-lg p-6">
//                 <h3 className="text-lg font-semibold text-gray-700 mb-4 text-center">
//                   {hasExistingRecording ? 'New Recording (will replace existing)' : 'New Recording'}
//                 </h3>
                
//                 <div className="flex justify-center gap-4 mb-4">
//                   {!isRecording ? (
//                     <button
//                       onClick={startRecording}
//                       disabled={micStatus !== 'ready'}
//                       className={`flex items-center gap-2 px-6 py-3 rounded-full transition shadow-lg ${
//                         micStatus !== 'ready'
//                           ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
//                           : 'bg-red-500 text-white hover:bg-red-600'
//                       }`}
//                     >
//                       <Mic className="w-5 h-5" />
//                       Start Recording
//                     </button>
//                   ) : (
//                     <button
//                       onClick={stopRecording}
//                       className="flex items-center gap-2 px-6 py-3 bg-gray-700 text-white rounded-full hover:bg-gray-800 transition shadow-lg animate-pulse"
//                     >
//                       <Square className="w-5 h-5" />
//                       Stop Recording
//                     </button>
//                   )}
//                 </div>

//                 {tempRecording && (
//                   <div className="space-y-4 p-4 bg-gray-50 rounded-lg">
//                     <p className="text-sm text-gray-600 text-center">
//                       Your new recording (not saved yet):
//                       <span className="ml-2 text-gray-400">({(tempRecording.size / 1024).toFixed(1)} KB)</span>
//                     </p>
                    
//                     {!hasListenedToRecording && (
//                       <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 text-center">
//                         <p className="text-sm text-yellow-700 font-medium">
//                           ⚠️ Please listen to your recording before saving
//                         </p>
//                       </div>
//                     )}
                    
//                     <div className="flex justify-center gap-4">
//                       <button
//                         onClick={() => playRecording(tempRecording.url)}
//                         className={`flex items-center gap-2 px-4 py-2 rounded-lg transition ${
//                           hasListenedToRecording 
//                             ? 'bg-blue-500 text-white hover:bg-blue-600' 
//                             : 'bg-blue-600 text-white hover:bg-blue-700 ring-2 ring-blue-300 animate-pulse'
//                         }`}
//                       >
//                         <Play className="w-4 h-4" />
//                         {hasListenedToRecording ? 'Play Again' : 'Play Your Recording'}
//                       </button>
//                       <button
//                         onClick={saveRecording}
//                         disabled={isSaving || !hasListenedToRecording || verificationStatus === 'verifying'}
//                         className={`flex items-center gap-2 px-4 py-2 rounded-lg transition ${
//                           hasListenedToRecording && !isSaving && verificationStatus !== 'verifying'
//                             ? 'bg-green-500 text-white hover:bg-green-600' 
//                             : 'bg-gray-300 text-gray-500 cursor-not-allowed'
//                         } disabled:opacity-50`}
//                         title={!hasListenedToRecording ? 'Please listen to your recording first' : ''}
//                       >
//                         <Save className="w-4 h-4" />
//                         {isSaving ? 'Saving...' : verificationStatus === 'verifying' ? 'Verifying...' : hasExistingRecording ? 'Replace Recording' : 'Save Recording'}
//                       </button>
//                     </div>
                    
//                     {hasListenedToRecording && !verificationStatus && (
//                       <div className="bg-green-50 border border-green-200 rounded-lg p-3 text-center">
//                         <p className="text-sm text-green-700">
//                           ✓ Recording reviewed - ready to save!
//                         </p>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               {/* Verification Status */}
//               <VerificationBlock />

//               {/* Existing Recording Section - hide when verification is showing */}
//               {hasExistingRecording && !verificationStatus && (
//                 <div className="border-2 border-green-200 rounded-lg p-6 bg-green-50">
//                   <h3 className="text-lg font-semibold text-green-700 mb-4 text-center">Currently Saved Recording</h3>
//                   <div className="flex justify-center">
//                     <button
//                       onClick={() => playCloudRecording(currentSyllable)}
//                       className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition shadow"
//                     >
//                       <Play className="w-5 h-5" />
//                       Play Saved Recording
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="flex justify-between mt-8">
//               <button
//                 onClick={goToPrevious}
//                 disabled={displayIndex === 0}
//                 className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 Previous {recordMode === 'unrecorded' && !allRecorded ? 'Unrecorded' : ''}
//               </button>
//               <button
//                 onClick={goToNext}
//                 disabled={displayIndex === totalInMode - 1}
//                 className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 Next {recordMode === 'unrecorded' && !allRecorded ? 'Unrecorded' : ''}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Summary Page
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 p-8">
//       <div className="max-w-6xl mx-auto">
//         <SpeakerHeader />
        
//         <div className="mb-6 flex justify-between items-center">
//           <h1 className="text-3xl font-bold text-gray-800">Recording Summary</h1>
//           <button
//             onClick={() => setCurrentPage('recorder')}
//             className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition"
//           >
//             Back to Recorder
//           </button>
//         </div>

//         <div className="bg-white rounded-2xl shadow-xl p-6 mb-6">
//           <div className="text-center">
//             <h2 className="text-xl font-semibold text-gray-700 mb-2">Progress</h2>
//             <div className="text-4xl font-bold text-purple-600">{completionPercentage}%</div>
//             <p className="text-gray-600 mt-1">
//               {Object.keys(recordings).length} of {hangulSyllables.length} syllables recorded
//             </p>
//             <div className="w-full bg-gray-200 rounded-full h-3 mt-4">
//               <div 
//                 className="bg-purple-600 h-3 rounded-full transition-all duration-300"
//                 style={{ width: `${completionPercentage}%` }}
//               />
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl shadow-xl p-6">
//           <div className="mb-4 flex items-center justify-between">
//             <div className="relative flex-1 mr-4">
//               <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
//               <input
//                 type="text"
//                 placeholder="Search syllables..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
//               />
//             </div>
//             <span className="text-gray-500 text-sm">
//               {hangulSyllables.length} syllables loaded
//             </span>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead>
//                 <tr className="border-b bg-gray-50">
//                   <th className="text-left py-3 px-4 font-semibold">Syllable</th>
//                   <th className="text-center py-3 px-4 font-semibold">Status</th>
//                   <th className="text-center py-3 px-4 font-semibold">Play</th>
//                   <th className="text-center py-3 px-4 font-semibold">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredSyllables.map((syllable) => {
//                   const syllableIndex = hangulSyllables.indexOf(syllable);
//                   const hasRecording = recordings[syllable] && recordings[syllable].saved;
                  
//                   return (
//                     <tr key={syllable} className="border-b hover:bg-gray-50 transition-colors">
//                       <td className="py-4 px-4">
//                         <button
//                           onClick={() => goToRecordSyllable(syllableIndex)}
//                           className="text-3xl font-bold hover:text-purple-600 transition-colors cursor-pointer"
//                           title="Click to record this syllable"
//                         >
//                           {syllable}
//                         </button>
//                       </td>
//                       <td className="py-4 px-4 text-center">
//                         {hasRecording ? (
//                           <span className="inline-flex items-center text-green-600 bg-green-50 px-3 py-1 rounded-full text-sm">
//                             <Check className="w-4 h-4 mr-1" />
//                             Recorded
//                           </span>
//                         ) : (
//                           <span className="text-gray-400 bg-gray-100 px-3 py-1 rounded-full text-sm">
//                             Not recorded
//                           </span>
//                         )}
//                       </td>
//                       <td className="py-4 px-4 text-center">
//                         {hasRecording ? (
//                           <button
//                             onClick={() => playCloudRecording(syllable)}
//                             className="p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition shadow-sm hover:shadow-md"
//                             title="Play recording"
//                           >
//                             <Play className="w-5 h-5" />
//                           </button>
//                         ) : (
//                           <span className="p-2 text-gray-300">
//                             <Play className="w-5 h-5" />
//                           </span>
//                         )}
//                       </td>
//                       <td className="py-4 px-4 text-center">
//                         <button
//                           onClick={() => goToRecordSyllable(syllableIndex)}
//                           className={`px-4 py-2 rounded-lg transition ${
//                             hasRecording 
//                               ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' 
//                               : 'bg-purple-600 text-white hover:bg-purple-700'
//                           }`}
//                         >
//                           {hasRecording ? 'Re-record' : 'Record'}
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>

//           {filteredSyllables.length === 0 && (
//             <div className="text-center py-8 text-gray-500">
//               No syllables found matching "{searchTerm}"
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default KoreanSyllableRecorder;











import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Mic, Square, Play, Save, Search, Check, User, LogOut, AlertTriangle } from 'lucide-react';
import ApiService, { RECORDER_KEY_STORAGE } from '../ApiService';

const MIN_VALID_AUDIO_SIZE = 500; // Minimum bytes for a valid audio recording

// Recorders routinely hit Stop a beat before they finish speaking, which clips
// the tail off the syllable. Keep capturing for a moment after the click.
const STOP_TAIL_MS = 150;

// Pause after playback finishes before the save button unlocks, so reviewing a
// take is a deliberate act rather than a click-through.
const LISTEN_GRACE_MS = 250;

// Audition set, recorded first so a new speaker can be vetted on 20 takes
// instead of 2,735. Chosen to probe what recorders actually get wrong:
//   가/카/까, 다/타/따, 바/파/빠, 자/차/짜 — the three-way plain/aspirated/tense
//     contrast at each place of articulation (the bilabial row also exposes
//     mic popping)
//   갇, 각 — unreleased finals; these stand in for every homophone spelling,
//     so an epenthetic vowel here poisons a whole group
//   강 — nasal coda    알 / 라 — final lateral vs initial flap
//   의, 위 — speaker-dependent glide realisation
//   턘 — a rare syllable, to see how they handle ones they've never said
const TRYOUT_SYLLABLES = [
  '가', '카', '까',
  '다', '타', '따',
  '바', '파', '빠',
  '자', '차', '짜',
  '갇', '각', '강',
  '알', '라',
  '의', '위',
  '턘',
];

// carl_stanhope -> Carl Stanhope, for greeting only. The raw value stays the
// storage folder name.
const displayName = (speaker) =>
  speaker
    .split('_')
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

// Shared surface styles, so every panel in the tool reads as one system.
const PAGE = 'min-h-screen bg-slate-50';
const CARD = 'bg-white rounded-xl border border-slate-200 shadow-sm';
const BTN_PRIMARY =
  'inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-purple-600 text-white text-sm font-medium hover:bg-purple-700 transition disabled:opacity-40 disabled:cursor-not-allowed';
const BTN_QUIET =
  'inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-white border border-slate-200 text-slate-700 text-sm font-medium hover:bg-slate-50 transition disabled:opacity-40 disabled:cursor-not-allowed';

// The syllable list runs to a few thousand entries. Rendering every row at once
// is what makes the summary feel sluggish, so grow the table on demand.
const ROWS_PER_PAGE = 100;

const KoreanSyllableRecorder = () => {
  const [currentPage, setCurrentPage] = useState('summary');
  const [visibleRows, setVisibleRows] = useState(ROWS_PER_PAGE);
  const [recordings, setRecordings] = useState({});
  const [hangulSyllables, setHangulSyllables] = useState([]);
  const [currentSyllableIndex, setCurrentSyllableIndex] = useState(0);
  const [isRecording, setIsRecording] = useState(false);
  const [tempRecording, setTempRecording] = useState(null);
  const [hasListenedToRecording, setHasListenedToRecording] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [recordMode, setRecordMode] = useState('unrecorded');
  const [recordingError, setRecordingError] = useState(null);
  const [micStatus, setMicStatus] = useState('initializing');
  const [verificationStatus, setVerificationStatus] = useState(null); // null, 'verifying', 'success', 'failed'
  const [verifiedAudioUrl, setVerifiedAudioUrl] = useState(null);
  const [, setVerifiedFileSize] = useState(null);
  
  // `speaker` is whatever the server says the auth key belongs to — it is never
  // typed in, because it doubles as the storage folder recordings are written to.
  const [speaker, setSpeaker] = useState('');
  const [keyInput, setKeyInput] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [isVerifyingKey, setIsVerifyingKey] = useState(false);

  const [isStopping, setIsStopping] = useState(false);
  const [isReviewPlaying, setIsReviewPlaying] = useState(false);

  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const streamRef = useRef(null);
  const stopTimeoutRef = useRef(null);
  const reviewAudioRef = useRef(null);
  const listenTimeoutRef = useRef(null);
  const apiService = useRef(new ApiService());

  const initializeMicrophone = useCallback(async () => {
    try {
      setMicStatus('initializing');
      setRecordingError(null);

      // Clean up old stream
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
      }

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;

      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: MediaRecorder.isTypeSupported('audio/webm;codecs=opus')
          ? 'audio/webm;codecs=opus'
          : 'audio/webm'
      });
      mediaRecorderRef.current = mediaRecorder;
      
      mediaRecorder.ondataavailable = (event) => {
        if (event.data && event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };
      
      mediaRecorder.onstop = () => {
        if (audioChunksRef.current.length === 0) {
          setRecordingError('No audio data was captured. Please check your microphone and try again.');
          setTempRecording(null);
          audioChunksRef.current = [];
          return;
        }

        const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
        console.log(`Recording complete: ${audioChunksRef.current.length} chunks, ${audioBlob.size} bytes`);

        if (audioBlob.size < MIN_VALID_AUDIO_SIZE) {
          setRecordingError(
            `Recording too small (${audioBlob.size} bytes). Your microphone may not be capturing audio. Please check your mic settings and try again.`
          );
          setTempRecording(null);
          audioChunksRef.current = [];
          return;
        }

        const audioUrl = URL.createObjectURL(audioBlob);
        setTempRecording({ blob: audioBlob, url: audioUrl, size: audioBlob.size });
        setHasListenedToRecording(false);
        setRecordingError(null);
        audioChunksRef.current = [];
      };

      mediaRecorder.onerror = (event) => {
        console.error('MediaRecorder error:', event.error);
        setRecordingError(`Recording error: ${event.error?.message || 'Unknown error'}`);
        setIsRecording(false);
      };

      // Listen for track ending (mic disconnected)
      stream.getAudioTracks().forEach(track => {
        track.addEventListener('ended', () => {
          setMicStatus('error');
          setRecordingError('Microphone was disconnected. Click "Reinitialize Microphone" to reconnect.');
          setIsRecording(false);
        });
      });

      setMicStatus('ready');
    } catch (err) {
      console.error('Error accessing microphone:', err);
      setMicStatus('error');
      setRecordingError(`Could not access microphone: ${err.message}`);
    }
  }, []);

  // Validate that the audio stream is actually active
  const validateStream = useCallback(() => {
    if (!streamRef.current) {
      setMicStatus('no-stream');
      setRecordingError('No audio stream. Please reinitialize your microphone.');
      return false;
    }

    const audioTracks = streamRef.current.getAudioTracks();
    if (audioTracks.length === 0) {
      setMicStatus('no-stream');
      setRecordingError('No audio tracks found. Please check your microphone.');
      return false;
    }

    const track = audioTracks[0];
    if (track.readyState !== 'live' || track.muted) {
      setMicStatus('error');
      setRecordingError(`Microphone issue: track is ${track.readyState}${track.muted ? ' (muted)' : ''}. Please reconnect your microphone.`);
      return false;
    }

    return true;
  }, []);

  const loadRecordingsStatus = useCallback(async () => {
    if (!speaker) return;
    
    try {
      setLoadingStatus(true);
      const status = await apiService.current.getSyllableRecordingsStatus({
        language: 'KR'
      });
      console.log('status: ', status);
      
      // Tryout syllables lead, so a new recorder's first 20 takes are the ones
      // worth auditioning. Everything else keeps the server's frequency order.
      const all = Object.keys(status);
      const tryout = TRYOUT_SYLLABLES.filter(s => all.includes(s));
      const tryoutSet = new Set(tryout);
      const syllables = [...tryout, ...all.filter(s => !tryoutSet.has(s))];
      setHangulSyllables(syllables);
      
      const formattedRecordings = {};
      Object.entries(status).forEach(([syllable, exists]) => {
        if (exists) {
          formattedRecordings[syllable] = { saved: true };
        }
      });
      setRecordings(formattedRecordings);
      
      const allRecorded = syllables.every(syllable => formattedRecordings[syllable]?.saved);
      if (allRecorded) {
        setRecordMode('all');
      } else {
        // Jump to first unrecorded syllable on load
        const firstUnrecordedIndex = syllables.findIndex(
          syllable => !formattedRecordings[syllable]?.saved
        );
        if (firstUnrecordedIndex !== -1) {
          setCurrentSyllableIndex(firstUnrecordedIndex);
        }
      }
    } catch (error) {
      console.error('Error loading recordings status:', error);
      setHangulSyllables([]);
    } finally {
      setLoadingStatus(false);
    }
  }, [speaker]);

  // A new take, or moving to another syllable, invalidates any playback in
  // flight — otherwise its pending timer could unlock save on the wrong audio.
  useEffect(() => {
    if (listenTimeoutRef.current) {
      clearTimeout(listenTimeoutRef.current);
      listenTimeoutRef.current = null;
    }
    if (reviewAudioRef.current) {
      reviewAudioRef.current.pause();
      reviewAudioRef.current = null;
    }
    setIsReviewPlaying(false);
  }, [tempRecording, currentSyllableIndex]);

  // Hand the key to the server and let it tell us who this is. Returns false
  // (and clears the stored key) if the server rejects it.
  const verifyAndLogin = useCallback(async (authKey) => {
    setIsVerifyingKey(true);
    setLoginError(null);
    localStorage.setItem(RECORDER_KEY_STORAGE, authKey);

    try {
      const { user } = await apiService.current.verifySyllableRecorderKey();
      setSpeaker(user);
      setIsLoggedIn(true);
      return true;
    } catch (error) {
      localStorage.removeItem(RECORDER_KEY_STORAGE);
      setSpeaker('');
      setIsLoggedIn(false);
      setLoginError(
        error.status === 401
          ? 'That key was not recognized.'
          : `Could not reach the server (${error.message}).`
      );
      return false;
    } finally {
      setIsVerifyingKey(false);
    }
  }, []);

  useEffect(() => {
    const savedKey = localStorage.getItem(RECORDER_KEY_STORAGE);
    if (savedKey) {
      verifyAndLogin(savedKey);
    }
  }, [verifyAndLogin]);

  useEffect(() => {
    if (isLoggedIn && speaker) {
      loadRecordingsStatus();
      initializeMicrophone();
    }

    return () => {
      if (stopTimeoutRef.current) {
        clearTimeout(stopTimeoutRef.current);
        stopTimeoutRef.current = null;
      }
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
      }
    };
  }, [isLoggedIn, speaker, loadRecordingsStatus, initializeMicrophone]);

  const handleLogin = async () => {
    const trimmedKey = keyInput.trim();
    if (!trimmedKey) return;

    const ok = await verifyAndLogin(trimmedKey);
    if (ok) {
      setKeyInput('');
    }
  };

  const handleLogout = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
    }
    setSpeaker('');
    setKeyInput('');
    setIsLoggedIn(false);
    setLoginError(null);
    setHangulSyllables([]);
    setRecordings({});
    setVerificationStatus(null);
    setVerifiedAudioUrl(null);
    setVerifiedFileSize(null);
    setRecordingError(null);
    localStorage.removeItem(RECORDER_KEY_STORAGE);
  };

  const playCloudRecording = async (syllable) => {
    try {
      const blob = await apiService.current.getProfessionalSyllableRecording({
        syllable,
        format: 'webm'
      });
      const audioUrl = URL.createObjectURL(blob);
      const audio = new Audio(audioUrl);
      
      audio.play();
      audio.addEventListener('ended', () => {
        URL.revokeObjectURL(audioUrl);
      });
    } catch (error) {
      console.error('Error playing cloud recording:', error);
      alert('Error playing recording. Please try again.');
    }
  };

  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1];
        if (!base64String) {
          reject(new Error('Base64 conversion failed: no data after split'));
          return;
        }
        resolve(base64String);
      };
      reader.onerror = () => reject(new Error('FileReader error during base64 conversion'));
      reader.readAsDataURL(blob);
    });
  };

  const getAudioFormatFromBlob = (blob) => {
    const mimeType = blob.type;
    const formatMap = {
      'audio/webm': 'webm',
      'audio/wav': 'wav',
      'audio/mpeg': 'mp3',
      'audio/mp3': 'mp3',
      'audio/ogg': 'ogg'
    };
    return formatMap[mimeType] || 'webm';
  };

  const startRecording = () => {
    setRecordingError(null);
    setVerificationStatus(null);
    setVerifiedAudioUrl(null);
    setVerifiedFileSize(null);

    // Validate stream is still active before recording
    if (!validateStream()) {
      return;
    }

    if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'inactive') {
      audioChunksRef.current = [];
      try {
        // Request data every 250ms to catch issues early
        mediaRecorderRef.current.start(250);
        setIsRecording(true);
        setTempRecording(null);
        setHasListenedToRecording(false);
      } catch (err) {
        console.error('Failed to start recording:', err);
        setRecordingError(`Failed to start recording: ${err.message}. Try reinitializing the microphone.`);
      }
    } else if (mediaRecorderRef.current) {
      setRecordingError(`MediaRecorder is in "${mediaRecorderRef.current.state}" state. Please wait or reinitialize.`);
    } else {
      setRecordingError('MediaRecorder not initialized. Please reinitialize the microphone.');
    }
  };

  const stopRecording = () => {
    const recorder = mediaRecorderRef.current;
    if (!recorder || recorder.state !== 'recording') return;
    if (stopTimeoutRef.current) return; // already winding down

    // Acknowledge the click straight away, but let the mic run on for
    // STOP_TAIL_MS so a trailing syllable still makes it into the file.
    setIsRecording(false);
    setIsStopping(true);

    stopTimeoutRef.current = setTimeout(() => {
      stopTimeoutRef.current = null;
      if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
        mediaRecorderRef.current.stop();
      }
      setIsStopping(false);
    }, STOP_TAIL_MS);
  };

  // Saving unlocks only once playback has actually finished, plus a short beat.
  // Clicking play and immediately saving is the failure this gate exists to stop.
  const playRecording = (audioUrl) => {
    if (!audioUrl) return;

    // Restart cleanly if they hit play again mid-playback
    if (listenTimeoutRef.current) {
      clearTimeout(listenTimeoutRef.current);
      listenTimeoutRef.current = null;
    }
    if (reviewAudioRef.current) {
      reviewAudioRef.current.pause();
    }

    const audio = new Audio(audioUrl);
    reviewAudioRef.current = audio;
    setIsReviewPlaying(true);

    audio.onended = () => {
      setIsReviewPlaying(false);
      listenTimeoutRef.current = setTimeout(() => {
        listenTimeoutRef.current = null;
        // Ignore if a new take or a different syllable took over meanwhile
        if (reviewAudioRef.current === audio) {
          setHasListenedToRecording(true);
        }
      }, LISTEN_GRACE_MS);
    };

    const fail = (message) => {
      setIsReviewPlaying(false);
      if (reviewAudioRef.current === audio) reviewAudioRef.current = null;
      setRecordingError(message);
    };

    audio.onerror = () => fail('Could not play back the recording.');
    audio.play().catch(err => fail(`Playback failed: ${err.message}`));
  };

  const getUnrecordedSyllables = useCallback(() => {
    return hangulSyllables
      .map((syllable, index) => ({ syllable, originalIndex: index }))
      .filter(({ syllable }) => !recordings[syllable] || !recordings[syllable].saved);
  }, [hangulSyllables, recordings]);

  // Verify a recording by pulling it back from blob storage
  const verifyRecordingFromStorage = async (syllable) => {
    setVerificationStatus('verifying');
    setVerifiedAudioUrl(null);
    setVerifiedFileSize(null);

    try {
      const blob = await apiService.current.getProfessionalSyllableRecording({
        syllable,
        format: 'webm'
      });

      console.log(`🔍 Verification for "${syllable}": fetched ${blob.size} bytes from storage`);

      if (!blob || blob.size < MIN_VALID_AUDIO_SIZE) {
        throw new Error(`File in storage is too small (${blob?.size || 0} bytes). The upload may have failed.`);
      }

      const audioUrl = URL.createObjectURL(blob);
      setVerifiedAudioUrl(audioUrl);
      setVerifiedFileSize(blob.size);
      setVerificationStatus('success');
      return true;
    } catch (error) {
      console.error(`❌ Verification failed for "${syllable}":`, error);
      setVerificationStatus('failed');
      setRecordingError(`Verification failed: ${error.message}. Please refresh your browser and try again.`);
      return false;
    }
  };

  // Advance to next syllable (called after successful verification)
  const advanceToNext = () => {
    if (verifiedAudioUrl) {
      URL.revokeObjectURL(verifiedAudioUrl);
    }
    setVerificationStatus(null);
    setVerifiedAudioUrl(null);
    setVerifiedFileSize(null);
    setTempRecording(null);
    setHasListenedToRecording(false);
    setRecordingError(null);

    if (recordMode === 'unrecorded') {
      const unrecordedSyllables = getUnrecordedSyllables();
      const currentUnrecordedIndex = unrecordedSyllables.findIndex(
        ({ originalIndex }) => originalIndex === currentSyllableIndex
      );
      if (currentUnrecordedIndex < unrecordedSyllables.length - 1) {
        const nextUnrecorded = unrecordedSyllables[currentUnrecordedIndex + 1];
        setCurrentSyllableIndex(nextUnrecorded.originalIndex);
      }
    } else {
      if (currentSyllableIndex < hangulSyllables.length - 1) {
        setCurrentSyllableIndex(currentSyllableIndex + 1);
      }
    }
  };

  const saveRecording = async () => {
    if (!tempRecording || isSaving || !hasListenedToRecording) return;

    // Validate blob size before saving
    if (!tempRecording.blob || tempRecording.blob.size < MIN_VALID_AUDIO_SIZE) {
      setRecordingError(
        `Cannot save: recording is too small (${tempRecording.blob?.size || 0} bytes). Please re-record.`
      );
      return;
    }

    setIsSaving(true);
    setRecordingError(null);
    setVerificationStatus(null);
    setVerifiedAudioUrl(null);
    setVerifiedFileSize(null);
    const syllable = hangulSyllables[currentSyllableIndex];
    
    try {
      const base64Audio = await blobToBase64(tempRecording.blob);

      // Validate base64 isn't empty
      if (!base64Audio || base64Audio.length < 100) {
        throw new Error(`Base64 conversion produced insufficient data: ${base64Audio?.length || 0} chars`);
      }

      const audioFormat = getAudioFormatFromBlob(tempRecording.blob);
      
      await apiService.current.saveProfessionalSyllableRecording({
        syllable,
        audio_data: base64Audio,
        language: 'KR',
        audio_format: audioFormat
      });

      console.log(`✅ Saved "${syllable}": ${tempRecording.blob.size} bytes`);
      
      setRecordings(prev => ({
        ...prev,
        [syllable]: { ...tempRecording, saved: true }
      }));

      // Now verify by pulling it back from storage
      setIsSaving(false);
      const verified = await verifyRecordingFromStorage(syllable);

      if (verified) {
        // Auto-advance to next syllable
        advanceToNext();
      } else {
        // Revert the local saved status since verification failed
        setRecordings(prev => {
          const updated = { ...prev };
          delete updated[syllable];
          return updated;
        });
      }
    } catch (error) {
      console.error('Error saving recording:', error);
      setRecordingError(`Failed to save: ${error.message}`);
      setIsSaving(false);
    }
  };

  const resetVerificationState = () => {
    if (verifiedAudioUrl) URL.revokeObjectURL(verifiedAudioUrl);
    setVerificationStatus(null);
    setVerifiedAudioUrl(null);
    setVerifiedFileSize(null);
    setTempRecording(null);
    setRecordingError(null);
  };

  // Throw away an unsaved take without immediately starting another one.
  const discardTake = () => {
    if (tempRecording?.url) URL.revokeObjectURL(tempRecording.url);
    setTempRecording(null);
    setHasListenedToRecording(false);
    setRecordingError(null);
  };

  const goToRecordSyllable = (syllableIndex) => {
    resetVerificationState();
    setCurrentSyllableIndex(syllableIndex);
    setCurrentPage('recorder');
    setHasListenedToRecording(false);
  };

  // Login screen
  if (!isLoggedIn) {
    return (
      <div className={`${PAGE} px-6 py-8 flex items-center justify-center`}>
        <div className={`${CARD} p-8 max-w-sm w-full`}>
          <div className="text-center mb-8">
            <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Mic className="w-6 h-6 text-purple-600" />
            </div>
            <h1 className="text-xl font-semibold text-slate-900">Korean Syllable Recorder</h1>
            <p className="text-sm text-slate-500 mt-1.5">Enter your recorder key to start</p>
          </div>

          <div className="space-y-3">
            <input
              type="password"
              placeholder="Recorder key"
              value={keyInput}
              onChange={(e) => setKeyInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
              disabled={isVerifyingKey}
              className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:bg-white transition disabled:opacity-50"
            />
            {loginError && (
              <div className="flex items-start gap-2 text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2">
                <AlertTriangle className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>{loginError}</span>
              </div>
            )}
            <button
              onClick={handleLogin}
              disabled={!keyInput.trim() || isVerifyingKey}
              className={`${BTN_PRIMARY} w-full py-2.5`}
            >
              {isVerifyingKey ? 'Checking...' : 'Start Recording'}
            </button>
          </div>

          <p className="text-xs text-slate-400 mt-6 text-center leading-relaxed">
            Your key identifies you — recordings save to your personal folder
          </p>
        </div>
      </div>
    );
  }

  // Loading screen
  if (loadingStatus || hangulSyllables.length === 0) {
    return (
      <div className={`${PAGE} px-6 py-8 flex items-center justify-center`}>
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-slate-200 border-t-purple-600 mx-auto mb-4"></div>
          <h2 className="text-base font-medium text-slate-700">Loading syllables</h2>
          <p className="text-sm text-slate-400 mt-1">for {displayName(speaker)}</p>
        </div>
      </div>
    );
  }

  const recordedCount = Object.keys(recordings).length;
  const completionPercentage = Math.round((recordedCount / hangulSyllables.length) * 100);
  const filteredSyllables = searchTerm
    ? hangulSyllables.filter(syllable => syllable.includes(searchTerm))
    : hangulSyllables;
  const shownSyllables = filteredSyllables.slice(0, visibleRows);

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    setVisibleRows(ROWS_PER_PAGE);
  };

  const SpeakerHeader = () => (
    <header className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 bg-purple-100 rounded-full flex items-center justify-center">
          <User className="w-4 h-4 text-purple-600" />
        </div>
        <div className="leading-tight">
          <p className="text-xs uppercase tracking-wide text-slate-400">Welcome</p>
          <p className="text-sm font-semibold text-slate-800">{displayName(speaker)}</p>
        </div>
      </div>
      <button
        onClick={handleLogout}
        className="inline-flex items-center gap-2 px-3 py-2 text-sm text-slate-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition"
        title="Switch speaker"
      >
        <LogOut className="w-4 h-4" />
        Sign out
      </button>
    </header>
  );

  // Mic status / error banner
  const StatusBanner = () => {
    if (micStatus === 'ready' && !recordingError) return null;

    const isError = micStatus === 'error' || micStatus === 'no-stream';

    return (
      <div className={`mb-4 px-4 py-3 rounded-lg border flex items-center justify-between gap-3 ${
        isError
          ? 'bg-red-50 border-red-200'
          : recordingError
            ? 'bg-amber-50 border-amber-200'
            : 'bg-slate-50 border-slate-200'
      }`}>
        <div className="flex items-center gap-2">
          <AlertTriangle className={`w-4 h-4 flex-shrink-0 ${isError ? 'text-red-500' : 'text-amber-500'}`} />
          <span className={`text-sm ${isError ? 'text-red-700' : 'text-amber-700'}`}>
            {recordingError || (micStatus === 'initializing' ? 'Initializing microphone...' : 'Microphone unavailable')}
          </span>
        </div>
        {isError && (
          <button
            onClick={initializeMicrophone}
            className="px-3 py-1.5 text-sm font-medium bg-red-600 text-white rounded-lg hover:bg-red-700 transition whitespace-nowrap"
          >
            Retry
          </button>
        )}
      </div>
    );
  };

  // Verification result UI (only shows during verification and on failure)
  const VerificationBlock = () => {
    if (!verificationStatus) return null;

    return (
      <>
        {verificationStatus === 'verifying' && (
          <div className="flex items-center gap-3 px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl">
            <div className="animate-spin rounded-full h-4 w-4 border-2 border-slate-200 border-t-purple-600"></div>
            <div>
              <p className="text-sm font-medium text-slate-700">Verifying upload</p>
              <p className="text-xs text-slate-400">Pulling the file back from storage to confirm it saved.</p>
            </div>
          </div>
        )}

        {verificationStatus === 'failed' && (
          <div className="px-4 py-3 bg-red-50 border border-red-200 rounded-xl">
            <div className="flex items-center gap-2">
              <AlertTriangle className="w-4 h-4 text-red-600" />
              <p className="text-sm font-medium text-red-800">Verification failed</p>
            </div>
            <p className="text-xs text-red-600 mt-1 mb-3">
              Could not retrieve a valid file from storage. The upload may have failed or the file is empty.
            </p>
            <div className="flex gap-2">
              <button
                onClick={() => {
                  setVerificationStatus(null);
                  setRecordingError(null);
                }}
                className="px-3 py-1.5 text-sm font-medium bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
              >
                Try again
              </button>
              <button
                onClick={() => window.location.reload()}
                className="px-3 py-1.5 text-sm font-medium bg-white border border-red-200 text-red-700 rounded-lg hover:bg-red-50 transition"
              >
                Refresh browser
              </button>
            </div>
          </div>
        )}
      </>
    );
  };

  // Recorder Page
  if (currentPage === 'recorder') {
    const unrecordedSyllables = getUnrecordedSyllables();
    const allRecorded = unrecordedSyllables.length === 0;
    
    let currentSyllable, displayIndex, totalInMode;
    
    if (recordMode === 'unrecorded' && !allRecorded) {
      const currentUnrecordedIndex = unrecordedSyllables.findIndex(
        ({ originalIndex }) => originalIndex === currentSyllableIndex
      );
      
      if (currentUnrecordedIndex === -1) {
        // Current syllable was just recorded — stay on it if we're verifying/saving,
        // otherwise show it using the "all" mode display so we don't snap away
        currentSyllable = hangulSyllables[currentSyllableIndex];
        displayIndex = currentSyllableIndex;
        totalInMode = hangulSyllables.length;
      } else {
        const currentUnrecordedSyllable = unrecordedSyllables[currentUnrecordedIndex];
        currentSyllable = currentUnrecordedSyllable.syllable;
        displayIndex = currentUnrecordedIndex;
        totalInMode = unrecordedSyllables.length;
      }
    } else {
      currentSyllable = hangulSyllables[currentSyllableIndex];
      displayIndex = currentSyllableIndex;
      totalInMode = hangulSyllables.length;
    }

    const hasExistingRecording = recordings[currentSyllable] && recordings[currentSyllable].saved;

    const goToPrevious = () => {
      resetVerificationState();
      if (recordMode === 'unrecorded' && !allRecorded) {
        const currentUnrecordedIndex = unrecordedSyllables.findIndex(
          ({ originalIndex }) => originalIndex === currentSyllableIndex
        );
        if (currentUnrecordedIndex > 0) {
          const prevUnrecorded = unrecordedSyllables[currentUnrecordedIndex - 1];
          setCurrentSyllableIndex(prevUnrecorded.originalIndex);
          setHasListenedToRecording(false);
        }
      } else {
        if (currentSyllableIndex > 0) {
          setCurrentSyllableIndex(currentSyllableIndex - 1);
          setHasListenedToRecording(false);
        }
      }
    };

    const goToNext = () => {
      resetVerificationState();
      if (recordMode === 'unrecorded' && !allRecorded) {
        const currentUnrecordedIndex = unrecordedSyllables.findIndex(
          ({ originalIndex }) => originalIndex === currentSyllableIndex
        );
        if (currentUnrecordedIndex < unrecordedSyllables.length - 1) {
          const nextUnrecorded = unrecordedSyllables[currentUnrecordedIndex + 1];
          setCurrentSyllableIndex(nextUnrecorded.originalIndex);
          setHasListenedToRecording(false);
        }
      } else {
        if (currentSyllableIndex < hangulSyllables.length - 1) {
          setCurrentSyllableIndex(currentSyllableIndex + 1);
          setHasListenedToRecording(false);
        }
      }
    };

    return (
      <div className={`${PAGE} px-6 py-8`}>
        <div className="max-w-2xl mx-auto">
          <SpeakerHeader />

          <StatusBanner />

          <div className="mb-4 flex justify-between items-center">
            <h1 className="text-2xl font-semibold text-slate-900">Korean Syllable Recorder</h1>
            <button onClick={() => setCurrentPage('summary')} className={BTN_QUIET}>
              View Summary
            </button>
          </div>

          {/* Mode + progress in one strip */}
          <div className={`${CARD} px-4 py-3 mb-6 flex items-center justify-between gap-4`}>
            <div className="flex gap-1 p-1 bg-slate-100 rounded-lg">
              <button
                onClick={() => {
                  setRecordMode('unrecorded');
                  if (unrecordedSyllables.length > 0) {
                    setCurrentSyllableIndex(unrecordedSyllables[0].originalIndex);
                  }
                }}
                disabled={allRecorded}
                className={`px-3 py-1.5 rounded-md text-sm font-medium transition ${
                  recordMode === 'unrecorded' && !allRecorded
                    ? 'bg-white text-slate-900 shadow-sm'
                    : allRecorded
                      ? 'text-slate-300 cursor-not-allowed'
                      : 'text-slate-600 hover:text-slate-900'
                }`}
              >
                Unrecorded {!allRecorded && unrecordedSyllables.length.toLocaleString()}
              </button>
              <button
                onClick={() => setRecordMode('all')}
                className={`px-3 py-1.5 rounded-md text-sm font-medium transition ${
                  recordMode === 'all' || allRecorded
                    ? 'bg-white text-slate-900 shadow-sm'
                    : 'text-slate-600 hover:text-slate-900'
                }`}
              >
                All {hangulSyllables.length.toLocaleString()}
              </button>
            </div>
            <div className="flex items-center gap-2 whitespace-nowrap">
              <div className="w-20 bg-slate-100 rounded-full h-1.5 overflow-hidden">
                <div
                  className="bg-purple-600 h-1.5 rounded-full transition-all duration-300"
                  style={{ width: `${completionPercentage}%` }}
                />
              </div>
              <span className="text-sm text-slate-500 tabular-nums">{completionPercentage}%</span>
            </div>
          </div>

          <div className={`${CARD} p-8`}>
            <div className="text-center mb-8">
              <p className="text-xs uppercase tracking-wide text-slate-400">
                {recordMode === 'unrecorded' && !allRecorded ? 'Unrecorded ' : ''}
                Syllable {(displayIndex + 1).toLocaleString()} of {totalInMode.toLocaleString()}
                {recordMode === 'unrecorded' && !allRecorded && (
                  <span className="block mt-1 normal-case tracking-normal text-slate-400">
                    #{(currentSyllableIndex + 1).toLocaleString()} of {hangulSyllables.length.toLocaleString()} overall
                  </span>
                )}
              </p>
              {TRYOUT_SYLLABLES.includes(currentSyllable) && (
                <span className="inline-flex items-center mt-2 text-[11px] font-medium uppercase tracking-wide text-purple-600 bg-purple-50 px-2 py-0.5 rounded-full">
                  Tryout {TRYOUT_SYLLABLES.indexOf(currentSyllable) + 1} of {TRYOUT_SYLLABLES.length}
                </span>
              )}
              <div className="text-8xl font-semibold text-slate-900 my-6 leading-none">{currentSyllable}</div>
              {hasExistingRecording ? (
                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-green-700 bg-green-50 px-2.5 py-1 rounded-full">
                  <Check className="w-3.5 h-3.5" />
                  Already recorded
                </span>
              ) : (
                <span className="inline-flex text-xs font-medium text-slate-500 bg-slate-100 px-2.5 py-1 rounded-full">
                  Not yet recorded
                </span>
              )}
            </div>

            <div className="space-y-4">
              <div className="border border-slate-200 rounded-xl p-6">
                <h3 className="text-xs uppercase tracking-wide text-slate-400 mb-4 text-center">
                  {hasExistingRecording ? 'New recording — replaces existing' : 'New recording'}
                </h3>

                {/* Left-to-right flow: record -> listen -> the take either gets
                    discarded or saved. Connectors are decorative and drop away
                    on narrow screens, where the buttons stack instead. */}
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
                  {isRecording ? (
                    <button
                      onClick={stopRecording}
                      className="inline-flex items-center justify-center gap-2 px-4 py-3 bg-slate-900 text-white rounded-lg text-sm font-medium hover:bg-slate-800 transition whitespace-nowrap"
                    >
                      <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" />
                      <Square className="w-4 h-4" />
                      Stop
                    </button>
                  ) : isStopping ? (
                    // Mic is still open for the tail — block a restart until it closes
                    <button
                      disabled
                      className="inline-flex items-center justify-center gap-2 px-4 py-3 bg-slate-100 text-slate-400 rounded-lg text-sm font-medium cursor-not-allowed whitespace-nowrap"
                    >
                      <Square className="w-4 h-4" />
                      Finishing...
                    </button>
                  ) : (
                    <button
                      onClick={startRecording}
                      disabled={micStatus !== 'ready'}
                      className={`inline-flex items-center justify-center gap-2 px-4 py-3 rounded-lg text-sm font-medium transition whitespace-nowrap ${
                        micStatus !== 'ready'
                          ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
                          : 'bg-red-500 text-white hover:bg-red-600'
                      }`}
                    >
                      <Mic className="w-4 h-4" />
                      {tempRecording ? 'Record again' : 'Record'}
                    </button>
                  )}

                  {/* record -> listen */}
                  <svg
                    className="hidden sm:block flex-shrink-0 text-slate-300"
                    width="24" height="12" viewBox="0 0 24 12" fill="none" aria-hidden="true"
                  >
                    <path d="M1 6 H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M15 2.5 L19 6 L15 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>

                  <button
                    onClick={() => tempRecording && playRecording(tempRecording.url)}
                    disabled={!tempRecording || isReviewPlaying || isRecording}
                    className={`inline-flex items-center justify-center gap-2 px-4 py-3 rounded-lg text-sm font-medium transition whitespace-nowrap ${
                      !tempRecording || isRecording
                        ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
                        : isReviewPlaying
                          ? 'bg-purple-100 text-purple-700 cursor-not-allowed'
                          : hasListenedToRecording
                            ? 'bg-white border border-slate-200 text-slate-700 hover:bg-slate-50'
                            : 'bg-purple-600 text-white hover:bg-purple-700'
                    }`}
                  >
                    <Play className="w-4 h-4" />
                    {isReviewPlaying ? 'Listening...' : 'Listen'}
                  </button>

                  {/* Listen branches to discard / save. Geometry matches the
                      column beside it: two 46px buttons (py-3 + 1px border) with
                      a 12px gap = 104px, so the curves land on button centres. */}
                  <svg
                    className="hidden sm:block flex-shrink-0 text-slate-300"
                    width="28" height="104" viewBox="0 0 28 104" fill="none" aria-hidden="true"
                  >
                    <path d="M1 52 C12 52, 14 23, 27 23" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M1 52 C12 52, 14 81, 27 81" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>

                  <div className="flex flex-col gap-3">
                    <button
                      onClick={discardTake}
                      disabled={!tempRecording || isSaving || isReviewPlaying || isRecording || verificationStatus === 'verifying'}
                      className="inline-flex items-center justify-center px-4 py-3 rounded-lg text-sm font-medium bg-white border border-slate-200 text-slate-600 hover:text-red-600 hover:border-red-200 hover:bg-red-50 transition whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:text-slate-600 disabled:hover:bg-white disabled:hover:border-slate-200"
                    >
                      Discard
                    </button>
                    <button
                      onClick={saveRecording}
                      disabled={!tempRecording || isSaving || !hasListenedToRecording || verificationStatus === 'verifying'}
                      // transparent border keeps this the same height as Discard,
                      // which the connector geometry depends on
                      className={`inline-flex items-center justify-center gap-2 px-4 py-3 rounded-lg border border-transparent text-sm font-medium transition whitespace-nowrap ${
                        tempRecording && hasListenedToRecording && !isSaving && verificationStatus !== 'verifying'
                          ? 'bg-green-600 text-white hover:bg-green-700'
                          : 'bg-slate-100 text-slate-400 cursor-not-allowed'
                      }`}
                      title={!hasListenedToRecording ? 'Listen to the whole recording first' : ''}
                    >
                      <Save className="w-4 h-4" />
                      {isSaving ? 'Saving...' : verificationStatus === 'verifying' ? 'Verifying...' : hasExistingRecording ? 'Replace recording' : 'Save recording'}
                    </button>
                  </div>
                </div>

                {/* Fixed height so the panel doesn't shift as this text changes */}
                <p className={`mt-4 text-xs text-center h-4 ${
                  !tempRecording
                    ? 'text-transparent'
                    : hasListenedToRecording
                      ? 'text-green-600'
                      : isReviewPlaying ? 'text-slate-400' : 'text-amber-600'
                }`}>
                  {tempRecording && (
                    <>
                      {hasListenedToRecording
                        ? '✓ Reviewed — ready to save'
                        : isReviewPlaying
                          ? 'Listening...'
                          : 'Listen all the way through before saving'}
                      <span className="ml-1.5 text-slate-400 tabular-nums">
                        ({(tempRecording.size / 1024).toFixed(1)} KB)
                      </span>
                    </>
                  )}
                </p>
              </div>

              {/* Verification Status */}
              <VerificationBlock />

              {/* Existing Recording Section - hide when verification is showing */}
              {hasExistingRecording && !verificationStatus && (
                <div className="border border-slate-200 rounded-xl p-4 flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-slate-700">Currently saved</p>
                    <p className="text-xs text-slate-400">The version in storage right now</p>
                  </div>
                  <button
                    onClick={() => playCloudRecording(currentSyllable)}
                    className={BTN_QUIET}
                  >
                    <Play className="w-4 h-4" />
                    Play
                  </button>
                </div>
              )}
            </div>

            <div className="flex justify-between mt-8 pt-6 border-t border-slate-100">
              <button
                onClick={goToPrevious}
                disabled={displayIndex === 0}
                className={BTN_QUIET}
              >
                Previous
              </button>
              <button
                onClick={goToNext}
                disabled={displayIndex === totalInMode - 1}
                className={BTN_QUIET}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Summary Page
  return (
    <div className={`${PAGE} px-6 py-8`}>
      <div className="max-w-5xl mx-auto">
        <SpeakerHeader />

        <h1 className="text-2xl font-semibold text-slate-900 mb-4">Recording Summary</h1>

        {/* Progress, with the way back into recording sitting right next to it */}
        <div className={`${CARD} p-6 mb-6`}>
          <div className="flex flex-col sm:flex-row sm:items-center gap-6">
            <div className="flex-1">
              <div className="flex items-baseline gap-3">
                <span className="text-4xl font-semibold text-purple-600 tabular-nums">
                  {completionPercentage}%
                </span>
                <span className="text-sm text-slate-500">
                  {recordedCount.toLocaleString()} of {hangulSyllables.length.toLocaleString()} syllables recorded
                </span>
              </div>
              <div className="w-full bg-slate-100 rounded-full h-2 mt-4 overflow-hidden">
                <div
                  className="bg-purple-600 h-2 rounded-full transition-all duration-300"
                  style={{ width: `${completionPercentage}%` }}
                />
              </div>
            </div>
            <button
              onClick={() => setCurrentPage('recorder')}
              className={`${BTN_PRIMARY} sm:self-center whitespace-nowrap px-5 py-2.5`}
            >
              <Mic className="w-4 h-4" />
              Continue Recording
            </button>
          </div>
        </div>

        <div className={CARD}>
          <div className="p-4 border-b border-slate-200 flex items-center gap-4">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 w-4 h-4" />
              <input
                type="text"
                placeholder="Search syllables..."
                value={searchTerm}
                onChange={(e) => handleSearchChange(e.target.value)}
                className="w-full pl-9 pr-4 py-2 text-sm bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:bg-white transition"
              />
            </div>
            <span className="text-slate-400 text-sm whitespace-nowrap tabular-nums">
              {filteredSyllables.length.toLocaleString()} shown
            </span>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-200">
                  <th className="text-left py-2.5 px-4 text-xs font-medium uppercase tracking-wide text-slate-500">Syllable</th>
                  <th className="text-left py-2.5 px-4 text-xs font-medium uppercase tracking-wide text-slate-500">Status</th>
                  <th className="text-right py-2.5 px-4 text-xs font-medium uppercase tracking-wide text-slate-500">Actions</th>
                </tr>
              </thead>
              <tbody>
                {shownSyllables.map((syllable) => {
                  const syllableIndex = hangulSyllables.indexOf(syllable);
                  const hasRecording = recordings[syllable] && recordings[syllable].saved;

                  return (
                    <tr key={syllable} className="border-b border-slate-100 last:border-0 hover:bg-slate-50 transition-colors">
                      <td className="py-3 px-4">
                        <button
                          onClick={() => goToRecordSyllable(syllableIndex)}
                          className="text-2xl font-semibold text-slate-800 hover:text-purple-600 transition-colors"
                          title="Click to record this syllable"
                        >
                          {syllable}
                        </button>
                      </td>
                      <td className="py-3 px-4">
                        {hasRecording ? (
                          <span className="inline-flex items-center gap-1.5 text-green-700 bg-green-50 px-2.5 py-1 rounded-full text-xs font-medium">
                            <Check className="w-3.5 h-3.5" />
                            Recorded
                          </span>
                        ) : (
                          <span className="inline-flex text-slate-400 bg-slate-100 px-2.5 py-1 rounded-full text-xs font-medium">
                            Not recorded
                          </span>
                        )}
                      </td>
                      <td className="py-3 px-4">
                        <div className="flex items-center justify-end gap-2">
                          {hasRecording && (
                            <button
                              onClick={() => playCloudRecording(syllable)}
                              className="p-2 text-slate-500 hover:text-purple-600 hover:bg-purple-50 rounded-lg transition"
                              title="Play recording"
                            >
                              <Play className="w-4 h-4" />
                            </button>
                          )}
                          <button
                            onClick={() => goToRecordSyllable(syllableIndex)}
                            className={hasRecording ? BTN_QUIET : BTN_PRIMARY}
                          >
                            {hasRecording ? 'Re-record' : 'Record'}
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {filteredSyllables.length === 0 && (
            <div className="text-center py-12 text-slate-400 text-sm">
              No syllables found matching "{searchTerm}"
            </div>
          )}

          {visibleRows < filteredSyllables.length && (
            <div className="p-4 border-t border-slate-200 flex items-center justify-center gap-3">
              <span className="text-xs text-slate-400 tabular-nums">
                Showing {shownSyllables.length.toLocaleString()} of {filteredSyllables.length.toLocaleString()}
              </span>
              <button
                onClick={() => setVisibleRows(visibleRows + ROWS_PER_PAGE)}
                className={BTN_QUIET}
              >
                Show more
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default KoreanSyllableRecorder;